import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNotifications } from 'redux/session/selectors';
import { InlineNotification } from 'carbon-components-react';
import { removeNotification } from 'redux/session/actions';

interface NotificationDetails {
  [key: string]: (data: any) => {
    id: string;
    message: string;
    details: string;
  };
}

const generateOrganisationSubscriptionExpiringDetails = ({
  remainingDays
}: {
  remainingDays: number;
}) => {
  const getDaysRemainingText = (days: number) => {
    if (days === 0) {
      return 'today';
    } else if (days === 1) {
      return `in ${days} day`;
    } else {
      return `in ${days} days`;
    }
  };

  return {
    id: 'organisation-subscription-expiring-notification',
    message: 'Warning',
    details: `Your organisation subscription expires ${getDaysRemainingText(
      remainingDays
    )}. Please contact your administrator for renewal.`
  };
};

const notificationDetails: NotificationDetails = {
  organisationSubscriptionExpiring:
    generateOrganisationSubscriptionExpiringDetails
};

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);

  return (
    <>
      {notifications?.map(({ id, data }) => {
        const notification = notificationDetails[id](data);

        return (
          <InlineNotification
            key={id}
            kind="warning"
            title={notification.message}
            subtitle={notification.details}
            lowContrast={true}
            iconDescription="Dismiss"
            data-testid={notification.id}
            id={notification.id}
            onCloseButtonClick={() => dispatch(removeNotification(id))}
          />
        );
      })}
    </>
  );
};

export default React.memo(Notifications);
